import { useEffect, useState } from "react";
import { getContactEmail } from "../HTTP/user";

export default function Footer() {

    const [adminEmail, setAdminEmail] = useState('contact@zemus.info')
    useEffect(() => {
        const fetchAdminEmail = async () => {
            const resAdminEmail = await getContactEmail();
            setAdminEmail(resAdminEmail.value);
        }
        fetchAdminEmail();
    }, []);

    return (
        <footer className="lg:mt-8 text-black mb-8">
            <div className="mx-auto text-center">
                <a href="/conditions" className="text-black hover:text-white">
                    Conditions d'utilisation
                </a>
                <span className="mx-2">|</span>
                <a href="/politique" className="text-black hover:text-white">
                    Politique de confidentialité
                </a>
                <span className="mx-2">|</span>
                <a href="/legales" className="text-black hover:text-white">
                    Mentions légales
                </a>
                <span className="mx-2">|</span>
                <a href="/about" className="text-black hover:text-white">
                    A Propos
                </a>
                <span className="mx-2">|</span>
                <a href={`mailto:${adminEmail}`} className="text-black hover:text-white">
                    Contact
                </a>
                <span className="mx-2">|</span>
                <span className="text-black">
                    © {new Date().getFullYear()} Bivilink. Tous droits réservés.
                </span>
            </div>
        </footer>
    );
}